module.exports = __webpack_public_path__ + "img/13.70f09e7d.png";